<template>
  <flex-layout
    class="toolbar-sub-btn h-100 px-3 py-2"
    :class="{ 'is-active': isActive }"
    justify="center"
    align="center"
    @click="onContainerClick"
    @keyup.enter="onContainerClick"
  >
    <base-text class="mx-auto my-auto pt-1 submenu-text"  bold size="xs" justify="center">
      {{ props.label }}
    </base-text>
    <base-icon
      v-if="props.menuItems.length"
      class="chevron"
      :class="{'chevron-transform': openMenu}"
      name="chevron-right"
    />
  </flex-layout>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import BaseText from '@/components/Texts/BaseText.vue';
import FlexLayout from '@/components/Layouts/FlexLayout.vue';
import BaseIcon from '@/components/Images/BaseIcon.vue';

interface MenuItem {
  text: string;
  route: string;
}

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  route: {
    type: String,
    required: false,
  },
  menuItems: {
    type: Array as () => MenuItem[],
    required: false,
    default: () => [],
  },
});

const router = useRouter();
const route = useRoute();
const openMenu = ref(false);
const emit = defineEmits<{(event: "click", value: void): void }>();

const isActive = computed(() => {
  if (!props.route) return false;

  const currentName = route.name as string | undefined;
  const parent = route.meta.parent as string | undefined;
  const lastSubMenu = sessionStorage.getItem("lastSubMenu");
  if (currentName === props.route) return true;
  if (parent && parent === props.route) return true;
  if (
    currentName?.includes("Detail") ||
    currentName?.includes("Inquiry") ||
    currentName?.includes("Hope")
  ) {
    return lastSubMenu === props.route;
  }
  return false;
});

function onContainerClick() {
  emit("click");
  if (props.route) {
    sessionStorage.setItem("lastSubMenu", props.route);
    router.push({ name: props.route });
  }
}
</script>

<style scoped>
.toolbar-sub-btn {
  cursor: pointer;
  position: relative;
}
.submenu-text {
  color: var(--bs-gray-600) !important;
  font-weight: 400 !important;

}
.toolbar-sub-btn.is-active .submenu-text {
  color: var(--primary) !important;
  font-weight: 700 !important;

}

.toolbar-sub-btn:not(.is-active):hover .submenu-text {
  color: var(--primary) !important;
  font-weight: 700 !important;

}

.chevron {
  color: var(--primary);
  position: absolute;
  right: 10px;
  transition: 0.3s ease-in-out;
}
.chevron-transform {
 transform: rotate(90deg);
}
</style>
